const booleanValues: Record<string, string> = {
  viteAppDEV: import.meta.env.VITE_APP_DEV || "REPLACE_VITE_APP_DEV",
  viteAppDisableDropshipping: import.meta.env.VITE_APP_DISABLE_DROPSHIPPING || "REPLACE_VITE_APP_DISABLE_DROPSHIPPING",
}

const getBoolean = (v: string) => booleanValues[v] === "true";

export const VITE_APP_AUTH_URL = import.meta.env.VITE_APP_AUTH_URL || "REPLACE_VITE_APP_AUTH_URL";
export const VITE_APP_API_URL = import.meta.env.VITE_APP_API_URL || "REPLACE_VITE_APP_API_URL";
export const VITE_APP_DEV = getBoolean("viteAppDEV");
export const VITE_APP_DISABLE_DROPSHIPPING = getBoolean("viteAppDisableDropshipping");
